import tw from 'tailwind-styled-components';

export const Container = tw.div`
flex
flex-col
items-center

`;

export const Header = tw.header`
flex
flex-col
items-center
mb-10
`;

export const H1 = tw.h1`
text-7xl
mb-6
`;

export const H1Span = tw.span`
font-bold
text-8xl
`;

export const H2 = tw.h2`
text-5xl
justify-center

`;

export const H3 = tw.h3`
text-4xl
justify-center
text-gray-700

`;

export const IssueDiv = tw.div`
bg-white
shadow-2xl
rounded-lg
m-auto
w-4/6
p-12
`;
